import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../context/ThemeContext';

const PrivacyPolicy: React.FC = () => {
  const { themeConfig } = useTheme();

  const sections = [
    {
      title: '1. Information We Collect',
      content: `We collect information you provide directly to us, such as:
      • Name and contact information when you fill out forms
      • Project requirements and business information
      • Communication records and correspondence
      • Payment information (processed securely through third-party providers)`,
    },
    {
      title: '2. How We Use Your Information',
      content: `Your information is used to:
      • Provide and improve our freelance services
      • Communicate about projects and services
      • Process payments and maintain records
      • Comply with legal obligations
      • Send project updates and important notifications`,
    },
    {
      title: '3. Information Sharing',
      content: `We do not sell, trade, or otherwise transfer your personal information to third parties except:
      • With your explicit consent
      • To comply with legal requirements
      • To protect our rights and safety
      • Through secure payment processors for transaction processing`,
    },
    {
      title: '4. Data Security',
      content: `We implement appropriate security measures to protect your personal information:
      • Secure data transmission using HTTPS
      • Limited access to personal information
      • Regular security assessments
      • Secure storage of project files and communications`,
    },
    {
      title: '5. Cookies and Tracking',
      content: `This website may use cookies to:
      • Remember your preferences
      • Analyze website usage
      • Improve user experience
      You can disable cookies in your browser settings if preferred.`,
    },
    {
      title: '6. Third-Party Services',
      content: `We use third-party services including:
      • Google Analytics for website analytics
      • Netlify for website hosting
      • Upwork for project management and payments
      • Email services for communication
      Each service has its own privacy policy.`,
    },
    {
      title: '7. Data Retention',
      content: `We retain your personal information only as long as necessary to:
      • Provide our services
      • Comply with legal obligations
      • Resolve disputes
      • Enforce our agreements
      Project files are typically retained for 2 years after completion.`,
    },
    {
      title: '8. Your Rights',
      content: `You have the right to:
      • Access your personal information
      • Correct inaccurate information
      • Request deletion of your information
      • Withdraw consent for data processing
      • Receive a copy of your data`,
    },
    {
      title: '9. Children\'s Privacy',
      content: `Our services are not directed to children under 13. We do not knowingly collect personal information from children under 13.`,
    },
    {
      title: '10. International Data Transfers',
      content: `Your information may be transferred to and processed in countries other than your country of residence. We ensure appropriate safeguards are in place for such transfers.`,
    },
    {
      title: '11. Changes to Privacy Policy',
      content: `We may update this privacy policy from time to time. We will notify you of significant changes by posting the new policy on this page with an updated date.`,
    },
    {
      title: '12. Contact Us',
      content: `If you have questions about this privacy policy or our data practices, please contact us at:
      Email: sharmachaitanya945@gmail.com
      Phone: +91-8750539794`,
    },
  ];

  return (
    <div className="min-h-screen">
      <section className={`${themeConfig.layout?.sectionStyle}`}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl font-bold mb-6 text-[var(--color-primary)]">Privacy Policy</h1>
          <p className="text-lg mb-8 text-[var(--color-text)] opacity-80">
            Last updated: September 2, 2025
          </p>
          
          <div className="prose max-w-none">
            <p className="text-[var(--color-text)] opacity-80 mb-8">
              This Privacy Policy describes how Chaitanya Sharma ("I", "me", "my") collects, uses, and 
              protects your information when you use my freelance services or visit my website.
            </p>

            <div className="space-y-8">
              {sections.map((section, idx) => (
                <motion.div
                  key={idx}
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: idx * 0.1 }}
                  viewport={{ once: true }}
                  className="p-6 rounded-lg border border-[var(--color-secondary)]"
                >
                  <h3 className="text-xl font-semibold mb-4 text-[var(--color-primary)]">
                    {section.title}
                  </h3>
                  <div className="text-[var(--color-text)] opacity-80 whitespace-pre-line">
                    {section.content}
                  </div>
                </motion.div>
              ))}
            </div>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className="mt-12 p-6 rounded-lg bg-[var(--color-secondary)] bg-opacity-20"
            >
              <h3 className="text-xl font-semibold mb-4 text-[var(--color-primary)]">Contact for Privacy Concerns</h3>
              <p className="text-[var(--color-text)] opacity-80 mb-4">
                If you have any questions about this Privacy Policy or our data practices:
              </p>
              <div className="space-y-2 text-[var(--color-text)] opacity-80">
                <p>📧 Email: sharmachaitanya945@gmail.com</p>
                <p>📞 Phone: +91-8750539794</p>
                <p>🌐 Website: https://sharmachaitanya945.com</p>
                <p>📍 Location: New Delhi, India</p>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
